const actions = {
  PACKAGE_FEATURE_ADD_BEGIN: 'PACKAGE_FEATURE_ADD_BEGIN',
  PACKAGE_FEATURE_ADD_SUCCESS: 'PACKAGE_FEATURE_ADD_SUCCESS',
  PACKAGE_FEATURE_ADD_ERR: 'PACKAGE_FEATURE_ADD_ERR',
  
  PACKAGE_FEATURES_READ_BEGIN: 'PACKAGE_FEATURES_READ_BEGIN',
  PACKAGE_FEATURES_READ_SUCCESS: 'PACKAGE_FEATURES_READ_SUCCESS',
  PACKAGE_FEATURES_READ_ERR: 'PACKAGE_FEATURES_READ_ERR',

  PACKAGE_FEATURE_UPDATE_BEGIN: 'PACKAGE_FEATURE_UPDATE_BEGIN',
  PACKAGE_FEATURE_UPDATE_SUCCESS: 'PACKAGE_FEATURE_UPDATE_SUCCESS',
  PACKAGE_FEATURE_UPDATE_ERR: 'PACKAGE_FEATURE_UPDATE_ERR',

  PACKAGE_FEATURE_DELETE_BEGIN: 'PACKAGE_FEATURE_DELETE_BEGIN',
  PACKAGE_FEATURE_DELETE_SUCCESS: 'PACKAGE_FEATURE_DELETE_SUCCESS',
  PACKAGE_FEATURE_DELETE_ERR: 'PACKAGE_FEATURE_DELETE_ERR',

  PACKAGE_FEATURE_READ_BEGIN: 'PACKAGE_FEATURE_READ_BEGIN',
  PACKAGE_FEATURE_READ_SUCCESS: 'PACKAGE_FEATURE_READ_SUCCESS',
  PACKAGE_FEATURE_READ_ERR: 'PACKAGE_FEATURE_READ_ERR',

  PACKAGE_FEATURE_UPLOAD_BEGIN: 'PACKAGE_FEATURE_UPLOAD_BEGIN',
  PACKAGE_FEATURE_UPLOAD_SUCCESS: 'PACKAGE_FEATURE_UPLOAD_SUCCESS',
  PACKAGE_FEATURE_UPLOAD_ERR: 'PACKAGE_FEATURE_UPLOAD_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.PACKAGE_FEATURES_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.PACKAGE_FEATURES_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.PACKAGE_FEATURES_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.PACKAGE_FEATURE_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.PACKAGE_FEATURE_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.PACKAGE_FEATURE_ADD_ERR,
      err,
    };
  },

  // Update

  axiosUpdateBegin: () => {
    return {
      type: actions.PACKAGE_FEATURE_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.PACKAGE_FEATURE_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.PACKAGE_FEATURE_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.PACKAGE_FEATURE_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.PACKAGE_FEATURE_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.PACKAGE_FEATURE_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.PACKAGE_FEATURE_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.PACKAGE_FEATURE_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.PACKAGE_FEATURE_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.PACKAGE_FEATURE_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.PACKAGE_FEATURE_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.PACKAGE_FEATURE_UPLOAD_ERR,
      err,
    };
  },

};

export default actions;
